'use client';
import { DashboardFilters } from '@/features/DashboardFilters';
import { PropertyList } from '@/features/PropertyList';
import { useUrlStateGroup } from '@/hooks/useUrlState';

export interface DashboardFilterValues {
  assigned: string | null;
  company: string | null;
}

const Page = () => {
  const { state, updateParams } = useUrlStateGroup({
    page: {
      defaultValue: 1,
      fromUrl: Number,
    },
    company: {
      defaultValue: null,
      fromUrl: String,
    },
    assigned: {
      defaultValue: null,
      fromUrl: String,
    },
  });

  const setFilters = (newFilters: DashboardFilterValues) => {
    if (newFilters.company === state.company && newFilters.assigned === state.assigned) {
      return;
    }
    updateParams({
      ...newFilters,
      page: 1,
    });
  };
  const setPage = (newPage: number) => {
    updateParams({ page: newPage });
  };
  const filters: DashboardFilterValues = {
    company: state.company,
    assigned: state.assigned,
  };

  return (
    <div className="flex flex-col gap-y-4">
      <DashboardFilters filters={filters} setFilters={setFilters} />
      <PropertyList filters={filters} activePage={state.page} setActivePage={setPage} />
    </div>
  );
};

export default Page;
